import { defineStore } from 'pinia'
import { ConstantStore } from '@/enum/store'
import { reactive, ref, watch } from 'vue'
import RootRouter, { healthRoute, homeRoute, systemRoute } from '@/router'
import VueRouter, { RouteRecordRaw } from 'vue-router'

const initAppRouterState: ROUTER.RouterRecords = {
  navbar: {
    route: [
      { name: '静源健康', key: 'health', path: '/health' },
      { name: '静源到家', key: 'home', path: '/home' },
      { name: '系统设置', key: 'system', path: '/system' }
    ],
    selectPath: '/health'
  },
  sider: {
    route: [],
    selectPath: '',
    openKeys: []
  }
}
const routeMap = new Map([
  ['/health', healthRoute.children],
  ['/home', homeRoute.children],
  ['/system', systemRoute.children]
])

export const useAppRouter = defineStore(ConstantStore.ROUTER, () => {
  const appRouter = reactive<ROUTER.RouterRecords>(initAppRouterState)

  const setSiderRoutes = () => {
    appRouter.sider.route = routeMap.get(appRouter.navbar.selectPath) as RouteRecordRaw[]
  }

  setSiderRoutes()

  const changeNavbarRoute = (route: ROUTER.RoutesProps) => {
    if (route.link) {
      window.open(route.path)
    } else {
      appRouter.navbar.selectPath = route.path
      RootRouter.push(route.path)
    }
  }

  // 根据当前子路由，逐级向上查找到根路由
  function findRootRoute (data, path: string) {
    const routes = RootRouter.options.routes as RouteRecordRaw[]

    const getParentRouteByPath = (routes: RouteRecordRaw, path: string) => {
      if (routes.children && routes.children.length > 0) {
        const index = routes.children.findIndex(route => route.path === path)
        return index >= 0
      } else {
        return false
      }
    }

    const fn = (route: RouteRecordRaw) => {
      const chidlren = route.children
      if (!chidlren) {
        console.log(route.path === path)
        if (route.path === path) return true
      } else {
        for (let i = 0; i < chidlren.length; i++) {
          fn(chidlren[i])
        }
      }
    }

    routes.forEach(route => {
      console.log('fn(route):', fn(route))

      if (fn(route)) {
        console.log('寻找顶级及诶点:', route.path)
      }
    })
  }

  console.log('appRouter:', appRouter)

  return {
    router: appRouter,
    setSiderRoutes,
    changeNavbarRoute,
    findRootRoute: (path) => findRootRoute(RootRouter.options.routes, path)
  }
}, {
  // persist: true
})
